// extracted by mini-css-extract-plugin
export var stepActive = "_1m-3";
export var stepCompleted = "_1m-4";
export var stepConnectorLine = "_1m-b";
export var stepIndicatorCircle = "_1m-6";
export var stepIndicatorCircleCompleted = "_1m-7";
export var stepIndicatorCircleDefault = "_1m-8";
export var stepIndicatorTextCompleted = "_1m-9";
export var stepIndicatorTextDefault = "_1m-a";
export var stepPending = "_1m-5";
export var wizardContainer = "_1m-1";
export var wizardContent = "_1m-2";
export var wizardModal = "_1m-0";